export enum NpsAction {
	'open' = 'open',
	'close' = 'close'
}
